import React from 'react';
import { IconButton, Theme, SxProps } from '@mui/material';
import { Palette, PaletteColor } from '@mui/material/styles/createPalette';

export const variants = {
    xs: 24,
    sm: 32,
    md: 48,
    lg: 72
};

export interface Props {
    noBackground?: boolean;
    variant?: keyof typeof variants;
    toggled?: boolean;
    palleteKey?: keyof Palette;
}

const getSxProps = (props: Props, theme: Theme): SxProps<Theme> => {
    const palette = theme.palette[props.palleteKey || 'secondary'] as PaletteColor;
    const bgColor = props.noBackground ? 'transparent' : props.toggled ? palette.light : palette.main;
    const size = variants[props.variant || 'md'];

    return {
        backgroundColor: bgColor,
        color: theme.palette.text.primary,
        width: size,
        height: size,
        '&:hover': {
            transition: '0.2s',
            backgroundColor: bgColor,
            opacity: '0.8',
            transform: 'scale(1.1)'
        },
        '&:disabled': {
            backgroundColor: theme.palette.secondary.main
        }
    };
};

export function RoundButton(props: Parameters<typeof IconButton>[0] & Props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { noBackground, variant, toggled, palleteKey, ...others } = props;
    return <IconButton {...others} sx={{ ...getSxProps }} />;
}
